<ng-template #toggleButton>
  <button
    type="button"
    class="form-heading cs-toggle"
    [id]="toggleId"
    [attr.aria-expanded]="open()"
    [attr.aria-controls]="bodyId"
    (click)="toggle()"
  >
    <span class="cs-label">{{ heading() }}</span>
    <svg
      class="cs-chevron"
      [class.cs-chevron--open]="open()"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      aria-hidden="true"
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
    </svg>
  </button>
</ng-template>
@switch (headingLevel()) {
  @case (2) {
    <h2 class="cs-heading"><ng-container [ngTemplateOutlet]="toggleButton" /></h2>
  }
  @case (3) {
    <h3 class="cs-heading"><ng-container [ngTemplateOutlet]="toggleButton" /></h3>
  }
  @case (4) {
    <h4 class="cs-heading"><ng-container [ngTemplateOutlet]="toggleButton" /></h4>
  }
  @default {
    <ng-container [ngTemplateOutlet]="toggleButton" />
  }
}
<div
  class="cs-body"
  [class.cs-body--open]="open()"
  [id]="bodyId"
  [attr.role]="headingLevel() ? 'region' : null"
  [attr.aria-labelledby]="headingLevel() ? toggleId : null"
  [attr.inert]="open() ? null : ''"
>
  <div class="cs-body-inner">
    <ng-content />
  </div>
</div>
